import { filter, map, switchMap, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';

import * as fromAuth from '../../auth/reducers'

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  currentLanguage = new BehaviorSubject<string>('en');

  constructor(private store: Store<any>) {
    store.pipe(
      select(fromAuth.getLanguage),
      filter(language => !!language))
      .subscribe(this.currentLanguage)
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const params = req.params
    if (req.method.toUpperCase() === 'GET' && !params.has('language')) {
      return this.currentLanguage
        .pipe(
          take(1),
          map(language => req.clone({
            params: req.params.append('language', language)
          })),
          switchMap((modifiedReq) => next.handle(modifiedReq))
        )
    } else {
      return next.handle(req);
    }
  }
}
